"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYFTokenFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var KYFTokenFactory = /** @class */ (function (_super) {
    __extends(KYFTokenFactory, _super);
    function KYFTokenFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    KYFTokenFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    KYFTokenFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    KYFTokenFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    KYFTokenFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    KYFTokenFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return KYFTokenFactory;
}(contracts_1.ContractFactory));
exports.KYFTokenFactory = KYFTokenFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_address",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "KyfStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "isVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "kyfInstances",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "kyfInstancesArray",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_kyfContract",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "setApprovedKYFInstance",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=KYFTokenFactory.js.map